module.exports = global["$"] = require("-!/opt/projects/lisboa_front/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js-exposed
// module id = 1626
// module chunks = 0